module.exports = __webpack_public_path__ + "static/media/icons.a44a66e1.svg";